import { Box, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  FiActivity,
  FiAward,
  FiBarChart2,
  FiBriefcase,
  FiCalendar,
  FiCheckCircle,
  FiCheckSquare,
  FiClipboard,
  FiClock,
  FiColumns,
  FiFolder,
  FiGrid,
  FiLayout,
  FiRefreshCw,
  FiShield,
  FiTag,
  FiUserCheck,
  FiUsers,
  FiVideo,
  FiZap,
} from "react-icons/fi";

// Cada `ref` do LinkItems tinha 1 dos 5 ícones de imagem reaproveitados entre
// 16 itens (ex.: Templates, ESG Starter, Pilares, Temas, GRI e GRI retroativo
// eram todos o MESMO ícone). Trocado por um ícone Feather distinto por item —
// a mesma família já usada no chevron do grupo e no form (gs-form-survey-ui).
const NAV_ICONS = {
  "survey-analysis": FiCheckSquare,
  registration: FiBriefcase,
  "access-requests": FiUserCheck,
  templates: FiLayout,
  "esg-starter": FiZap,
  pillars: FiColumns,
  themes: FiTag,
  "gri-indicators": FiBarChart2,
  "comparison-groups": FiUsers,
  researches: FiClipboard,
  certifications: FiAward,
  cronogramas: FiCalendar,
  audit: FiShield,
  documents: FiFolder,
  "dashboards-geral": FiGrid,
  "dashboards-portfolio": FiAward,
  "dashboards-fluxo": FiRefreshCw,
  "dashboards-historico": FiClock,
  "dashboards-por-empresa": FiBriefcase,
  "dashboards-qualidade": FiCheckCircle,
  "gri-dashboard": FiActivity,
  "educational-content": FiVideo,
};

const ACTIVE_BG = "#E7F1FA";
const ACTIVE_COLOR = "#0073BB";
const INACTIVE_COLOR = "#5C6066";
const ICON_MUTED = "#9AA5B1";

// EG-27 (design alinhado ao form) + refresh: item ativo ganha barra de
// destaque à esquerda + ícone/texto na cor da marca; inativo fica
// dessaturado com hover suave.
//
// `active` vem de fora (Topbar), calculado pelo prefixo mais longo entre
// TODOS os itens do menu — este componente não sabe dos irmãos, então não
// dava pra resolver aqui a colisão entre rotas que compartilham prefixo
// (ex.: /dashboards e /dashboards/portfolio).
export default function NavItem({ icon, path, name, children, active, ...rest }) {
  const Icon = NAV_ICONS[icon];

  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <Flex
        pos="relative"
        align="center"
        gap="12px"
        pl="16px"
        pr="12px"
        py="10px"
        mb="2px"
        borderRadius="10px"
        cursor="pointer"
        transition="background-color 0.15s ease"
        bg={active ? ACTIVE_BG : "transparent"}
        _hover={active ? {} : { bg: "#F3F4F7" }}
        {...rest}
      >
        <Box
          pos="absolute"
          left="0"
          top="22%"
          bottom="22%"
          w="3px"
          borderRadius="full"
          bg={ACTIVE_COLOR}
          opacity={active ? 1 : 0}
          transition="opacity 0.15s ease"
        />

        {Icon && (
          <Icon
            size={18}
            color={active ? ACTIVE_COLOR : ICON_MUTED}
            style={{ flexShrink: 0, transition: "color 0.15s ease" }}
          />
        )}

        <Text
          as="span"
          lineHeight="normal"
          fontWeight={active ? 700 : 600}
          fontSize="14.5px"
          color={active ? ACTIVE_COLOR : INACTIVE_COLOR}
          noOfLines={1}
        >
          {name}
        </Text>
      </Flex>
    </Link>
  );
}
